import React from 'react';
import {change, formValueSelector, getFormValues} from "redux-form";
import {bindActionCreators} from 'redux';

/**
 * Třída, která slouží pro vložení formuláře do části FormSection, tato třída zpřístupní v propsech vkládaného formuláře metodu prefixName a formName hlavního formuláře a change metodu,
 * která správně vygeneruje prefix pro field ve vnořeném formuláři, např. pro použití ve field selectoru.
 *
 * Pro získání instance formuláře může sloužit VÝJIMEČNĚ metoda getWrappedInstance.
 *
 * Příklad použití:
 *
 * // Vložení
 * <FormSection name="subjekt.kontakt">
 *     <form.ReduxSectionForm form={KontaktForm} />
 * </FormSection>
 *
 * // Selektorv KontaktForm
 * const prefixName = props.prefixName || (x => x);
 * const formName = props.formName || KontaktForm.formName;
 * const selector = formValueSelector(formName);
 * const dorucovatNa = selector(state, prefixName("dorucovatNa"));
 *
 * @type {{contextTypes}}
 */
const ReduxSectionForm = class extends React.Component {
    static contextTypes = {
        _reduxForm: React.PropTypes.object
    };

    getWrappedInstance = () => {
        return this.refs.form;
    };

    render() {
        const {form, children, ...other} = this.props;
        const {_reduxForm, _reduxForm : {sectionPrefix}} = this.context;
        const prefixName = (name = "") => !sectionPrefix ? name : (name ? `${sectionPrefix}.${name}` : `${sectionPrefix}`);
        // Název prefixu pro použití v např. area pro dynamické store, tedy neobsahuje tečky
        const prefixNameArea = (name = "") => (!sectionPrefix ? name : (name ? `${sectionPrefix}.${name}` : `${sectionPrefix}`)).replace(/\./g, '_');

        const formChange = (field, value) => { return change(_reduxForm.form, prefixName(field), value) };

        // --------------
        // Funkce - chování jako standardní form
        // const array = {
        //     insert: bindActionCreators(formChange, _reduxForm.arrayInsert
        // };

        // --------------
        // Specifické pro form redux form section
        const parts = sectionPrefix.split(".");
        const sectionGetFormValues = (state) => {
            let formValues = getFormValues(_reduxForm.form)(state);
            for (let a=0; a<parts.length; a++) {
                if (!formValues) {
                    break;
                }
                formValues = formValues[parts[a]];
            }
            return formValues;
        };
        const sectionSelector = (state, field) => {
            const selector = formValueSelector(_reduxForm.form);
            return selector(state, prefixName(field));
        };

        // --------------

        const props = {
            ...other,
            prefixName,   // funkce, která vygeneruje správně název fieldu ve vnořeném formuláři
            dynamicArea: prefixNameArea(),     // název area pro dynamické store
            change: bindActionCreators(formChange, _reduxForm.dispatch),
            formName: _reduxForm.form, // název hlavního formuláře, pro umístění konkrétního fieldu je nutné přidat cestu sectionPrefix
            ref: "form",
            sectionForm: {
                getFormValues: sectionGetFormValues,
                selector: sectionSelector
            }
        };
        return React.createElement(form, props, children);
    }
};


export default ReduxSectionForm;
